import vConsole from "vconsole";
import { useLanguagePlugin, useDarkModePlugin } from "./plugins";

export const initVConsole = () => {
  // 正式环境外或者链接带有'vConsole'参数才引入VConsole
  if (!__PROD__ || /vConsole/.test(location.href)) {
    const vc = new vConsole();
    // 使用语言切换插件
    useLanguagePlugin(vc);
    // 使用深色模式切换插件
    useDarkModePlugin(vc);
  }
}
